module.exports = __webpack_public_path__ + "img/espanyol-logo-icon.796b8074.png";